

const initialState = {
    terms_conditions: [],
    contract: [],
    contract_pdf: null,
    error: null,
    isLoding: false
  };
  
const ContractApiReducer =(state = initialState, action)=> {
    switch (action.type) {
        case "LOADING":
          return {
            ...state,
            isLoding: action.payload
        };

        case "GET_CONTRACT_TERMS_AND_CONDITIONS_SUCCESS":
            return {
                ...state,
                terms_conditions: action.payload,
                error: null
            };
        case "GET_CONTRACT_TERMS_AND_CONDITIONS_FAILURE":
            return {
                ...state,
                error: action.payload.error
            };
      
        case "ADD_CONTRACT_TERM_AND_CONDITIONS_SUCCESS":
              return {
                ...state,
                terms_conditions: [...state.terms_conditions, action.payload],
                error: null
              };
        case "ADD_CONTRACT_TERM_AND_CONDITIONS_FAILURE":
              return {
                ...state,
                error: action.payload.error
              };
      
        case "UPDATE_TERMS_AND_CONDITIONS_SUCCESS":
              return{
                  ...state,
                  error: action.payload.error
              };
            
        case "UPDATE_TERMS_AND_CONDITIONS_FAILURE":
              return{
                  ...state,  
                  error: action.payload.error
              };
            
        case "DELETE_TERMS_AND_CONDITIONS_SUCCESS":
              return{
                  ...state,
                  terms_conditions: state.terms_conditions.map((emp) =>
                  emp.id === action.payload.id ? action.payload : emp
                ),
                  error: null
              };
            
        case "DELETE_TERMS_AND_CONDITIONS_FAILURE":
              return{
                  ...state,
                  error: action.payload.error
              };
              
        case "GET_CONTRACT_SUCCESS":
            return {
                ...state,
                contract: action.payload,
                error: null
            };
        case "GET_CONTRACT_FAILURE":
            return {
                ...state,
                error: action.payload.error
            };
      
        case "ADD_CONTRACT_SUCCESS":
              return {
                ...state,
                contract: [...state.contract, action.payload],
                error: null
              };
        case "ADD_CONTRACT_FAILURE":
              return {
                ...state,
                error: action.payload.error
              };
      
        case "UPDATE_CONTRACT_SUCCESS":
              return{
                  ...state,
                  error: action.payload.error
              };
            
        case "UPDATE_CONTRACT_FAILURE":
              return{
                  ...state,  
                  error: action.payload.error
              };
            
        case "DELETE_CONTRACT_SUCCESS":
              return{
                  ...state,
                  contract: state.contract.map((emp) =>
                  emp.id === action.payload.id ? action.payload : emp
                ),
                  error: null
              };
            
        case "DELETE_CONTRACT_FAILURE":
              return{
                  ...state,
                  error: action.payload.error
              };

         case "DOWNLOAD_CONTRACT_PDF_SUCCESS":
        return {
          ...state,
          contract_pdf: action.payload,
          error: null
        };
      case "DOWNLOAD_CONTRACT_PDF_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
        
        default:
                return state;

};
};

export default ContractApiReducer;